export class TrainingScheduleVersionEvaluation {
	constructor() {
	}
} 
